export const OrgType = {
    solo: "solo",
    fleet: "fleet",
};
export const Role = {
    owner: "owner",
    dispatcher: "dispatcher",
    driver: "driver",
};
export const MembershipStatus = {
    invited: "invited",
    active: "active",
    removed: "removed",
};
export const LoadStatus = {
    considering: "considering",
    passed: "passed",
    booked: "booked",
    rolling: "rolling",
    delivered: "delivered",
    paid: "paid",
    cancelled: "cancelled",
};
export const LoadSource = {
    typed: "typed",
    screenshot: "screenshot",
    ratecon: "ratecon",
    tracker: "tracker",
    legacy_import: "legacy_import",
};
export const StopKind = {
    pickup: "pickup",
    drop: "drop",
};
export const TrailerType = {
    flatbed: "flatbed",
    step_deck: "step_deck",
    lowboy: "lowboy",
    conestoga: "conestoga",
    dry_van: "dry_van",
    reefer: "reefer",
    other: "other",
};
export const DocumentKind = {
    ratecon: "ratecon",
    bol: "bol",
    pod: "pod",
    screenshot: "screenshot",
    fuel_receipt: "fuel_receipt",
    maintenance_receipt: "maintenance_receipt",
    other: "other",
};
export const ExpenseKind = {
    fuel: "fuel",
    maintenance: "maintenance",
    toll: "toll",
    scale: "scale",
    permit: "permit",
    other: "other",
};
export const SettlementStatus = {
    draft: "draft",
    final: "final",
    paid: "paid",
};
export const PlanId = {
    free: "free",
    solo: "solo",
    fleet: "fleet",
};
export const SubscriptionStatus = {
    trialing: "trialing",
    active: "active",
    past_due: "past_due",
    canceled: "canceled",
    incomplete: "incomplete",
    none: "none",
};
export const Verdict = {
    enter_rate: "enter_rate",
    you_keep: "you_keep",
    take_it: "take_it",
    thin: "thin",
    barely: "barely",
    pass: "pass",
};
export const SyncEntity = {
    driver: "driver",
    truck: "truck",
    trailer: "trailer",
    pay_contract: "pay_contract",
    broker: "broker",
    broker_contact: "broker_contact",
    load: "load",
    load_stop: "load_stop",
    load_event: "load_event",
    document: "document",
    expense: "expense",
    detention: "detention",
    cost_profile: "cost_profile",
};
export const PayContractKind = {
    lease_pct: "lease_pct",
    per_mile: "per_mile",
    flat: "flat",
};
export const FscRuleKind = {
    from_load: "from_load",
    fixed_per_mile: "fixed_per_mile",
};
export const CostRuleKind = {
    per_mile: "per_mile",
    weekly_truck: "weekly_truck",
};
//# sourceMappingURL=enums.js.map